"use strict"

import Axios from "../../../services/AxiosService"

class Service extends Axios {
  constructor() {
    super()
  }
  async signIn(data: { email: string; password: string }) {
    return this.request({
      method: "POST",
      url: "/signIn",
      offline: false,
      data,
    })
  }

  async profile() {
    return this.request({
      method: "get",
      url: "/profile",
    })
  }
}

export default () => new Service()
